import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import './rsbutton.css'
import intConvertImg from "../../assets/img/interested-icon.png"
const ActionInterested = ({to, onClick, children}) => {
  return (
    <Link
      to={to}
      className={`btn btn-edit`}
      onClick={onClick}
    >
      <img src={intConvertImg} style={{width:22}} /> {children}
    </Link>
  );
};

ActionInterested.propTypes = {
to:PropTypes.string,
onClick: PropTypes.func,
children: PropTypes.string,
};
ActionInterested.defaultProps = {
    to:'#',
    onClick: () => {},
    children:''
  };
export default ActionInterested;
